import React, {useEffect, useRef} from 'react';
import {useQueryClient} from '@tanstack/react-query';
import useWebSocket from '@src/hooks/useWebSocket';
import app from '@src/helpers/app';
import {randomInteger} from '@src/helpers/rand';
import {FormSubscriberProps} from '@src/@types/components/Form';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import FormSubscriber from '@src/components/Form/FormSubscriber';

export default function OrderFormSubscriber<
        Model extends IEmptyModel = IOrderModel
>(props: FormSubscriberProps<Model>) {
    const queryClient = useQueryClient();
    const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

    const {lastMessage} = useWebSocket<{ orderId?: string }>({
        model: 'order-product-file',
        event: '*',
        enabledOnlyWhenAuthorized: true,
    });
    const {formName, model} = props;
    const modelId = model?.order_id ?? model?.id;// `model` can be `IOrderModel` or `IOrderProductModel`, so...
    const recordId = model?.id;

    useEffect(() => () => {
        if (timer.current) {
            clearTimeout(timer.current);
        }
    }, []);

    useEffect(() => {
        if (!lastMessage || !formName || !modelId || !lastMessage.orderId || modelId !== lastMessage.orderId) {
            return;
        }

        if (timer.current) {
            clearTimeout(timer.current);
        }

        timer.current = setTimeout(() => {
            const key = app('queryKeys').getDetailsOfRecordQueryKey(formName, recordId);

            queryClient.refetchQueries(key, {type: 'active'}).then();
        }, randomInteger(1000, 3000));
    }, [formName, lastMessage, modelId, queryClient, recordId]);

    return <FormSubscriber {...props}>{props.children}</FormSubscriber>;
}
